import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import CrimeVictimDetails from "./CrimeVictimDetails"

const CrimeVictimTab = ({ inWorkQ }) => {
    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Crime Victim</h2>
                <NotesComponent noteTypeId={6} inWorkQ={inWorkQ}/>
            </div>
        </TabHeader>
        <div>
            <CrimeVictimDetails />
        </div>
    </>
}

export default CrimeVictimTab